import React, { Component, Fragment } from 'react';
import { Container, Button, Form, Dropdown, DropdownButton } from 'react-bootstrap';
import { GoLock, GoTrash, GoPencil, GoWorkflow } from 'react-icons/go';
import { PiShippingContainer } from "react-icons/pi";
import { GoSync } from "react-icons/go";
import { MdOutlineExpandMore } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import Select, { components } from "react-select";
import Styles from "../../controls/common/styles";
import Tooltip from "../../controls/common/tooltip";
import Utils from "context/utils";
import AddDefinitionModal from "./addDefinition";
import DeleteDefinitionModal from "./deleteDefinition";
import CreateSessionModal from "../../debugger/sessions/create";
import "./index.css";


export default class Selector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addDefinitionModalShow: false,
      definitionToBeEdited: null,
      deleteDefinitionModalShow: false,
      createSessionModalShow: false
    };
  }

  /**
   * Add new
   */

  setAddDefinitionModalShow(show) {
    this.setState({
      addDefinitionModalShow: show,
      definitionToBeEdited: null
    });
  }

  handleAddDefinition(definition) {
    this.props.shell.shellInterface.updateProgress(true, "Creating new playground definition...", false, null);

    const layout = (definition.layoutType === "grid")
      ? { type: "grid", columns: definition.columns, row_height: definition.rowHeight }
      : { type: "free_form" };

    const body = {
      engine: "workflow_blobhub",
      command: "create_definition",
      category: "playground",
      alias: definition.alias,
      layout,
    };
    this.props.app.api.revisionsIdDataCommandPost(this.props.revision.id, body)
      .then( response => {
        // Remove progress
        this.props.shell.shellInterface.updateProgress(false, null, false, null);

        // Retrieve definition
        const definition = response.data["definition"];

        // Re-load definitions
        this.props.shell.shellInterface.reloadDefinitions(definition.id);
      }, error => {
        // Render error state
        this.props.shell.shellInterface.updateProgress(
          false, null, true, "Failed to create playground definition: " + error.message);
      });
  }

  /**
   * Edit
   */

  setEditDefinitionModalShow(show) {
    this.setState({
      addDefinitionModalShow: show,
      definitionToBeEdited: show ? this.props.shell.definition : null
    });
  }

  handleEditDefinition(definition) {
    this.props.shell.shellInterface.updateProgress(true, "Applying playground definition changes...", false, null);

    const body = {
      engine: "workflow_blobhub",
      command: "update_definition",
      definition_id: definition.id,
      alias: definition.alias
    };
    this.props.app.api.revisionsIdDataCommandPost(this.props.revision.id, body)
      .then( response => {
        // Remove progress
        this.props.shell.shellInterface.updateProgress(false, null, false, null);

        // Re-load definitions
        this.props.shell.shellInterface.reloadDefinitions(definition.alias);
      }, error => {
        // Render error state
        this.props.shell.shellInterface.updateProgress(
          false, null, true, "Failed to update playground definition: " + error.message);
      });
  }

  /**
   * Delete
   */

  setDeleteDefinitionModalShow(show) {
    this.setState({deleteDefinitionModalShow: show});
  }

  handleDeleteDefinition() {
    this.props.shell.shellInterface.updateProgress(true, "Deleting playground definition...", false, null);

    const definition = this.props.shell.definition;
    const body = {
      engine: "workflow_blobhub",
      command: "delete_definition",
      definition_id: definition["id"]
    };
    this.props.app.api.revisionsIdDataCommandPost(this.props.revision.id, body)
      .then( response => {
        // Remove progress
        this.props.shell.shellInterface.updateProgress(false, null, false, null);

        // Re-load definitions
        this.props.shell.shellInterface.reloadDefinitions(null);
      }, error => {
        // Render error state
        this.props.shell.shellInterface.updateProgress(
          false, null, true, "Failed to delete playground definition: " + error.message);
      });
  }

  /**
   * Session
   */

  handleCreateSession(session) {
    this.props.sessionManager.createNewSession(session);
  }

  render() {
    const disabled = this.props.shell.modified;

    // Definitions select
    let currentDefinitionOption = null;
    let definitionOptions = [];
    for ( const definition of this.props.shell.definitions ) {
      const definitionOption = {
        value: definition,
        label: definition["alias"]
      };
      definitionOptions.push(definitionOption);
      if ( definition["id"] == this.props.shell.definitionId ) {
        currentDefinitionOption = definitionOption;
      }
    }

    // Sessions select
    let currentSessionOption = null;
    let sessionOptions = [];
    if (this.props.sessionManager.sessions) {
      for ( const session of this.props.sessionManager.sessions ) {
        let sessionOption = null;
        if ( session["id"] != this.props.sessionManager.sessionId ) {
          sessionOption = {
            value: session,
            label: (
              <div className="playground-session-select-option">
                <p><code>{session["id"]}</code></p>
                <p>{Utils.formatDateTime(session["created_at"], this.props.timezone)}</p>
                {session["description"] &&
                  <p className="text-muted">{session["description"]}</p>
                }
              </div>
            )
          };
        } else {
          sessionOption = {
            value: session,
            label: session["id"]
          };
          currentSessionOption = sessionOption;
        }
        sessionOptions.push(sessionOption);
      }
    }
    
    // This one is used to hide controls in parallel with `disabled`. They never interfere.
    const canEdit = this.props.shell.shellInterface.canEditRevision();

    return (
      <>
        <Container className="blob-header-row content-row workflow-selector-container">
          <div className="blob-download-row workflow-selector-row">
            {0 != this.props.shell.definitions.length &&
              <>
                <span>
                  Playground&nbsp;&nbsp;&nbsp;
                </span>
                <span>
                  <div className="playground-selector-dropdown">
                    <Select
                      isDisabled={disabled}
                      options={definitionOptions}
                      value={currentDefinitionOption}
                      onChange={(option) => {
                        this.props.shell.shellInterface.switchDefinition(option.value);
                      }}
                      menuPortalTarget={document.body}
                      styles={Styles.headerSelect()}
                    />
                  </div>
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;
                  {canEdit &&
                    <Dropdown className="d-inline-block">
                      <Dropdown.Toggle
                        variant="light"
                        size="sm"
                        className="align-middle playground-action-dropdown-toggle"
                        disabled={disabled}
                        style={{ marginTop: "-2px" }}
                      >
                        <BsThreeDotsVertical />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => this.setAddDefinitionModalShow(true)}>
                          <GoWorkflow />&nbsp;&nbsp;New Playground
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => this.setEditDefinitionModalShow(true)}>
                          <GoPencil />&nbsp;&nbsp;Edit Playground
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => this.setDeleteDefinitionModalShow(true)}>
                          <GoTrash />&nbsp;&nbsp;Delete Playground
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={() => this.props.shell.shellInterface.getSync().loadPrerequisites()}>
                          <GoSync />&nbsp;&nbsp;Refresh Workflows
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  }
                </span>
              </>
            }
            {0 == this.props.shell.definitions.length &&
              <span>
                Create the first playground definition here.
              </span>
            }

            <span className="float-right">
              <span>
                Session&nbsp;&nbsp;&nbsp;
              </span>
              <span>
                <div className="session-selector-dropdown">
                  <Select
                    isDisabled={disabled}
                    options={sessionOptions}
                    value={currentSessionOption}
                    onChange={(option) => {
                      const session = option.value;
                      this.props.shell.shellInterface.sessionSelected(session);
                    }}
                    menuPortalTarget={document.body}
                    styles={Styles.headerSelect()}
                  />
                </div>
              </span>
              <span>
                &nbsp;&nbsp;&nbsp;
                <Dropdown className="d-inline-block">
                  <Dropdown.Toggle
                    variant="light"
                    size="sm"
                    className="align-middle playground-action-dropdown-toggle"
                    disabled={disabled}
                    style={{ marginTop: "-2px" }}
                  >
                    <BsThreeDotsVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {this.props.shell.shellInterface.canEditRevision() &&
                      <Dropdown.Item onClick={() => {
                          this.setState({ createSessionModalShow: true });
                        }}>
                        <PiShippingContainer />&nbsp;&nbsp;New Session
                      </Dropdown.Item>
                    }
                    <Dropdown.Item onClick={() => {
                        this.props.sessionManager.loadSessions(false);
                      }}>
                      <GoSync />&nbsp;&nbsp;Refresh Sessions
                    </Dropdown.Item>
                    {this.props.sessionManager.lastSessionId &&
                      <Dropdown.Item onClick={() => {
                          this.props.sessionManager.loadSessions(true);
                        }}>
                        <MdOutlineExpandMore />&nbsp;&nbsp;Load More Sessions
                      </Dropdown.Item>
                    }
                  </Dropdown.Menu>
                </Dropdown>

                &nbsp;&nbsp;&nbsp;
                <Form.Check
                  id="playground-session-sync-switch"
                  type="switch" label="Sync" inline
                  disabled={disabled}
                  checked={this.props.sessionManager.sessionSync}
                  onChange={(event) => {
                    this.props.shell.shellInterface.enableSessionSync(event.target.checked);
                  }}
                />
              </span>
            </span>
          </div>
        </Container>

        <AddDefinitionModal
          show={this.state.addDefinitionModalShow}
          onHide={() => this.setAddDefinitionModalShow(false)}
          handleAddDefinition={(definition) => this.handleAddDefinition(definition)}
          handleEditDefinition={(definition) => this.handleEditDefinition(definition)}
          definition={this.state.definitionToBeEdited}
        />

        <DeleteDefinitionModal
          show={this.state.deleteDefinitionModalShow}
          onHide={() => this.setDeleteDefinitionModalShow(false)}
          handleDeleteDefinition={() => this.handleDeleteDefinition()}
          definition={this.props.shell.definition}
        />

        <CreateSessionModal
          show={this.state.createSessionModalShow}
          onHide={() => this.setState({ createSessionModalShow: false })}
          handleCreate={(session) => this.handleCreateSession(session)}
        />
      </>
    );
  }
}
